import React from 'react';
import { useGlobalChat } from '../../contexts/GlobalChatContext';

/**
 * Higher-Order Component that injects global chat context into class components
 */
const withGlobalChat = (WrappedComponent) => {
  const WithGlobalChatComponent = (props) => {
    const globalChatContext = useGlobalChat();
    
    return (
      <WrappedComponent 
        {...props} 
        globalChat={globalChatContext}
      />
    );
  };

  WithGlobalChatComponent.displayName = `withGlobalChat(${WrappedComponent.displayName || WrappedComponent.name})`;
  
  return WithGlobalChatComponent;
};

export default withGlobalChat;